export default "__VITE_ASSET__536a4f16__"